import Router from 'vue-router';
import Vue from 'vue';
Vue.use(Router)
const vueRouter = new Router({
  base: process.env.VUE_APP_PATH,
  mode: process.env.VUE_APP_MODE,
})

vueRouter.beforeEach((to, from, next) => {
  // console.log('to',to)
  // console.log('from', from)
  if(to.path.includes('/view')){
    next();
  } else if(to.path.includes('/login')){
   // console.log('登录页')
    next();
  } else {
    let token = localStorage.getItem('token');
    if (token === 'export') {
      next({path:'exportData'})
    } else if (token === 'admin') {
      next();
    } else if (token === 'control') {
      next({path:'control'});
    } else {
     // console.log('没有token')
      next({ path: 'login' });
    }
  }

  /*if (to.path === '/login') {
    next();
  } else if(to.path.includes('view')) {
    next();
  } else if(to.path.includes('operationAllocation')) {
    next();
  } else {
    // 从本地存储里获取token
    let token = localStorage.getItem('token');
    console.log("成功判断")
    // 判断token是否为空如果为空则跳转到登录页 如果有则放行
    if (token === null || token === '') {
      next({ path: '/login' });
    } else {
      next();
    }
  }*/
});
export default vueRouter;
